import { render, staticRenderFns } from "./StoreSplitAccountDetail.vue?vue&type=template&id=fb6113be&scoped=true"
import script from "./StoreSplitAccountDetail.vue?vue&type=script&lang=ts"
export * from "./StoreSplitAccountDetail.vue?vue&type=script&lang=ts"
import style0 from "./StoreSplitAccountDetail.vue?vue&type=style&index=0&id=fb6113be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6113be",
  null
  
)

export default component.exports